import React from 'react';
import SignUp from '../SignUp';

// Wrapper route that reuses the SignUp screen UI.
// The SignUp component detects complete-signup mode based on this prop (and history state)
// and will disable email/password inputs + skip Cognito signup.
export default function CompleteSignUp(props) {
  return <SignUp {...props} completeSignup />;
}
